import React from 'react';
import { Clock, MapPin } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { clinicInfo } from '../../mock';
import { officeHours } from '../../enhancedMock';

export const OfficeHoursLocation = () => (
  <section data-testid="office-hours-section" className="fade-in-section py-12 md:py-20 px-4 bg-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto max-w-6xl">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">Visit Us</h2>
        <p className="text-sm md:text-xl text-gray-600">We're here when you need us</p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-8">
        <Card className="border-none shadow-xl bg-white">
          <CardHeader className="p-4 md:p-6">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-primaryOrange rounded-full flex items-center justify-center mb-3 md:mb-4 mx-auto">
              <Clock className="text-white" size={24} />
            </div>
            <CardTitle className="text-center text-xl md:text-2xl text-darkBrown">Office Hours</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2 md:space-y-3 p-4 pt-0 md:p-6 md:pt-0">
            {Object.entries(officeHours).map(([day, hours]) => (
              <div key={day} className="flex justify-between items-center py-1.5 md:py-2 border-b border-gray-100">
                <span className="font-semibold text-darkBrown capitalize text-sm md:text-base">{day}</span>
                <span className="text-gray-600 text-sm md:text-base">{hours}</span>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card className="border-none shadow-xl bg-white overflow-hidden">
          <CardHeader className="p-4 md:p-6">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-primaryOrange rounded-full flex items-center justify-center mb-3 md:mb-4 mx-auto">
              <MapPin className="text-white" size={24} />
            </div>
            <CardTitle className="text-center text-xl md:text-2xl text-darkBrown">Our Location</CardTitle>
          </CardHeader>
          <CardContent className="p-4 pt-0 md:p-6 md:pt-0">
            <p className="text-center font-semibold text-darkBrown mb-3 md:mb-4 text-sm md:text-base">{clinicInfo.address}</p>
            <div className="aspect-video rounded-lg overflow-hidden">
              <iframe
                width="100%"
                height="100%"
                frameBorder="0"
                style={{ border: 0 }}
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3455.6789!2d-95.2345!3d29.9987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjnCsDU5JzU1LjMiTiA5NcKwMTQnMDQuMiJX!5e0!3m2!1sen!2sus!4v1234567890"
                allowFullScreen
                title="FAVOR HCS Location"
              ></iframe>
            </div>
            <p className="text-xs md:text-sm text-gray-600 mt-3 md:mt-4 text-center">
              <strong>Parking:</strong> Free parking available in front of building
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  </section>
);
